export default "__VITE_ASSET__C8dOH9Mx__"